import {
  AutoComplete,
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Layout,
  Row,
  Select,
  Spin,
  Tabs,
  Breadcrumb,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate, useParams,Link } from "react-router-dom";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import InputField from "../../common/htmlComponents/InputField";
import { ReactComponent as AddressLine } from "../../image/AddressLine.svg";
import { ReactComponent as ZipCode } from "../../image/ZipCode.svg";
import "../../styles/Main.scss";
import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import verifybtn from "../../image/verifybtn.png";
import { Content } from "antd/lib/layout/layout";
import ShippingSiteLocationKeyPerson from "./../../feature/deliveryAddress/ShippingSiteLocationKeyPerson";
import BillingSiteLocationKeyPerson from "./BillingSiteLocationKeyPerson";
import SiteWiseMaterialCompany from "../companyMaterialMaster/SIteWiseMaterialCompany";
import TabPane from "antd/lib/tabs/TabPane";
import SiteMaterialStep from "../companyMaterialMaster/SiteMaterialStep";
import { InfoCircleOutlined } from "@ant-design/icons";

const EditMaterial = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { Option } = Select;
  const { id } = useParams();
  const AddressId = id ? id : null;
  const formRef = useRef();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const userId = authUserData()?.user_id ? authUserData()?.user_id : null;
  const initialState = {
    company: authUserData()?.company,
    company_legal_name: "",
    site_name: "",
    gst_number: "",
    gst_no_verified: false,
    wbs_choice: "Common Wise For Site",
    common_wbs_number: "",
    billing_state: "",
    billing_city: "",
    billing_address_line_1: "",
    billing_address_line_2: "",
    billing_landmark: "",
    billing_pincode: "",
    billing_email: "",
    billing_phone: "",
    billing_alternative_phone_number: "",
    billing_contact_person_name: "",
    shipping_state: "",
    shipping_city: "",
    shipping_address_line_1: "",
    shipping_address_line_2: "",
    shipping_landmark: "",
    shipping_pincode: "",
    shipping_email: "",
    shipping_phone: "",
    sameAsCurrentAddress: false,
    shipping_alternative_phone_number: "",
    shipping_contact_person_name: "",
    wbs_numbers: [
      {
        wbs_number: null,
        category: 1,
      },
    ],
    delivery_address_billing_keypersons: [
      {
        persons_name: null,
        mobile_number: null,
        email: null,
      },
    ],
    delivery_address_shipping_keypersons: [
      {
        persons_name: null,
        mobile_number: null,
        email: null,
      },
    ],
  };

  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const [pincodeListBilling, setPincodeListBilling] = useState([]);
  const [searchValueBilling, setSearchValueBilling] = useState("");
  const [pincodeListShipping, setPincodeListShipping] = useState([]);
  const [searchValueShipping, setSearchValueShipping] = useState("");
  const [selectedOption, setSelectedOption] = useState("Common Wise For Site");
  const [categoryTree, setCategoryTree] = useState([]);
  const [sameAsCurrentAddress, setSameAsCurrentAddress] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [identifyProfileUrl, setIdentifyProfileUrl] = useState(null);
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [btnLoadingVerifyGst, setBtnLoadingVerifyGst] = useState(false);
  const [verifyGstDisable, setVerifyDisable] = useState(true);
  const [verifyGstButtonView, setVerifyGstButtonView] = useState(true);
  const [activeKey, setActiveKey] = useState("1");

  const handleTabChange = async (key) => {
    setActiveKey(key);
  };

  useEffect(() => {
    const addressGetById = async () => {
      try {
        setapiLoading(true);
        const apiResponse = await getRequest(`delivery-address/${AddressId}/`);
        if (apiResponse.data.success) {
            handleTabChange('2')
          const {
            id,
            wbs_number,

            ...filteredResponse
          } = apiResponse.data.data;

          setState({
            ...filteredResponse,

            delivery_address_billing_keypersons:
              apiResponse.data.data.delivery_address_billing_keypersons.map(
                (e) => ({
                  persons_name: e.persons_name,
                  id: e.id,
                  address_master: e.address_master,
                  email: e.email,
                  mobile_number: e.mobile_number,
                })
              ),
          });
          const delivery_address_billing_keypersons =
            apiResponse.data.data.delivery_address_billing_keypersons.map(
              (e) => ({
                persons_name: e.persons_name,
                email: e.email,
                mobile_number: e.mobile_number,
              })
            );

          setWeightSizeFieldValue(
            apiResponse.data.data.delivery_address_billing_keypersons
          );

          const url = apiResponse.data.data.company_address_master_logo;

          setIdentifyProfileUrl(
            apiResponse.data.data.company_address_master_logo
          );
          if (url !== null) {
            setFileList([
              {
                url: url,
              },
            ]);
          }

          if (apiResponse?.data?.data?.gst_no_verified === true) {
            setVerificationStatus("success");
            setVerifyGstButtonView(false);
          } else {
            setVerificationStatus(null);
            setVerifyGstButtonView(true);
          }

          formRef.current.setFieldsValue({
            ...apiResponse.data.data,

            company_legal_name: apiResponse.data.data.company_legal_name,
            shipping_pincode: apiResponse.data.data.shipping_pincode_number,
            shipping_phone: String(apiResponse.data.data.shipping_phone),
            shipping_alternative_phone_number: String(
              apiResponse.data.data.shipping_alternative_phone_number
            ),
            billing_pincode: apiResponse.data.data.billing_pincode_number,
            billing_phone: String(apiResponse.data.data.billing_phone),
            billing_alternative_phone_number: String(
              apiResponse.data.data.billing_alternative_phone_number
            ),
          });

          const response = apiResponse.data.data;
          if (
            response?.billing_state === response?.shipping_state &&
            response?.billing_city === response?.shipping_city &&
            response?.billing_address_line_1 ===
              response?.shipping_address_line_1 &&
            response?.billing_address_line_2 ===
              response?.shipping_address_line_2 &&
            response?.billing_landmark === response?.shipping_landmark &&
            response?.billing_pincode === response?.shipping_pincode &&
            response?.billing_email === response?.shipping_email &&
            response?.billing_phone === response?.shipping_phone &&
            response?.billing_alternative_phone_number ===
              response?.shipping_alternative_phone_number &&
            response?.shipping_contact_person_name ===
              response?.billing_contact_person_name
          ) {
            setSameAsCurrentAddress(true);
          }
        } else {
          ErrorNotificationMsg(t("error_in_list_delivery_address"));
          sameAsCurrentAddress(false);
        }
        setapiLoading(false);
      } catch (error) {
        setapiLoading(false);
      }
    };

    if (AddressId !== null) {
      addressGetById();
    }
  }, [AddressId, t, activeKey]);

  useEffect(() => {
    getCategoryTree();
  }, []);

  const updateSubscriptionStatus = async () => {
    const response = await getRequest(`user-detail/${userId}`);
    localStorage.setItem("auth_data", JSON.stringify(response.data.data));
  };

  const handlePincodeBillingChange = async (billing_pincode) => {
    if (
      billing_pincode !== null &&
      billing_pincode !== undefined &&
      billing_pincode !== "" &&
      billing_pincode.length > 4
    ) {
      try {
        const response = await getRequest(
          `pincode/?search_pincode_number=${billing_pincode}`
        );
        if (response.data.results.data.length > 0) {
          const { state_name, city_name, id, pincode_number } =
            response.data.results.data[0];
          setState((prevState) => ({
            ...prevState,
            billing_state: state_name,
            billing_city: city_name,
            billing_pincode: id,
            billing_pincode_number: pincode_number,
          }));
          formRef.current.setFieldsValue({
            billing_state: state_name,
            billing_city: city_name,
          });
        }
      } catch (error) {
        console.error("Error fetching state and city:", error);
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        billing_state: "",
        billing_city: "",
        billing_pincode: null,
        billing_pincode_number: "",
      }));
      formRef.current.setFieldsValue({ billing_state: "", billing_city: "" });
    }
  };

  const searchINBilling = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );

    if (apiResponse.data.results.success) {
      setPincodeListBilling(apiResponse.data.results.data);
    }
  };

  const onSearchBilling = async (value) => {
    setSearchValueBilling(value);
    value.length >= 4
      ? searchINBilling(!value ? null : value)
      : setPincodeListBilling([]);
  };

  const handlePincodeShippingChange = async (shipping_pincode) => {
    if (
      shipping_pincode !== null &&
      shipping_pincode !== undefined &&
      shipping_pincode !== "" &&
      shipping_pincode.length > 4
    ) {
      try {
        const response = await getRequest(
          `pincode/?search_pincode_number=${shipping_pincode}`
        );
        if (response.data.results.data.length > 0) {
          const { state_name, city_name, id } = response.data.results.data[0];
          setState((prevState) => ({
            ...prevState,
            shipping_state: state_name,
            shipping_city: city_name,
            shipping_pincode: id,
          }));
          formRef.current.setFieldsValue({
            shipping_state: state_name,
            shipping_city: city_name,
          });
        }
      } catch (error) {
        console.error("Error fetching state and city:", error);
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        shipping_state: "",
        shipping_city: "",
        shipping_pincode: null,
      }));
      formRef.current.setFieldsValue({ shipping_state: "", shipping_city: "" });
    }
  };
  const searchINShipping = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );

    if (apiResponse.data.results.success) {
      setPincodeListShipping(apiResponse.data.results.data);
    }
  };

  const onSearchShipping = async (value) => {
    setSearchValueShipping(value);
    value.length >= 4
      ? searchINShipping(!value ? null : value)
      : setPincodeListShipping([]);
  };

  const getCategoryTree = async (data) => {
    await getRequest("category-tree/?no_pagination=True", data).then(
      (response) => {
        setCategoryTree(response.data.data);
      }
    );
  };

  const gstPattern =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  const handleGstInputChange = async (name, value) => {
    setVerifyGstButtonView(true);

    setState({ ...state, [name]: value, gst_no_verified: false });
    setVerificationStatus(null);
    setVerifyDisable(!gstPattern.test(value));
  };
  const handleGstNumberVerify = async () => {
    setVerifyDisable(true);
    setVerifyGstButtonView(true);
    try {
      setBtnLoadingVerifyGst(true);
      const gst = state?.gst_number;

      const response = await getRequest(`doc-verification/gst/?gst_no=${gst}`);

      if (response.data.results.data) {
        SuccessNotificationMsg("GST verified successfully");
        setVerificationStatus("success");
        setBtnLoadingVerifyGst(false);
        setVerifyGstButtonView(false);
        setVerifyDisable(false);
      } else {
        ErrorNotificationMsg(t("Invalid GST No."));
        setBtnLoadingVerifyGst(false);
        setVerifyGstButtonView(true);
        setVerifyDisable(false);
      }
    } catch (error) {
      ErrorNotificationMsg(t("Error in verifying GST number"));
      // setVerificationStatus("failure");
      setBtnLoadingVerifyGst(false);
      setVerifyGstButtonView(true);
      setVerifyDisable(false);
    }
  };
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  const handleSelectChange = (name, value) => {
    setState({ ...state, [name]: value });
  };
  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      const payload1 = {
        company: state.company,
        company_legal_name: state.company_legal_name,
        site_name: state.site_name,
        gst_number: state.gst_number,
        gst_no_verified: state.gst_no_verified,
        billing_state: state.billing_state,
        billing_city: state.billing_city,
        billing_address_line_1: state.billing_address_line_1,
        billing_address_line_2: state.billing_address_line_2,
        billing_landmark: state.billing_landmark,
        billing_pincode: state.billing_pincode,
        shipping_state: state.shipping_state,
        shipping_city: state.shipping_city,
        shipping_address_line_1: state.shipping_address_line_1,
        shipping_address_line_2: state.shipping_address_line_2,
        shipping_landmark: state.shipping_landmark,
        shipping_pincode: state.shipping_pincode,
        same_as_billing_address: state.same_as_billing_address,
        delivery_address_billing_keypersons:
          state.delivery_address_billing_keypersons &&
          state.delivery_address_billing_keypersons.every(
            (person) =>
              person.persons_name === null &&
              person.email === null &&
              person.mobile_number === null
          )
            ? []
            : state.delivery_address_billing_keypersons,

        delivery_address_shipping_keypersons:
          state.delivery_address_shipping_keypersons &&
          state.delivery_address_shipping_keypersons.every(
            (person) =>
              person.persons_name === null &&
              person.email === null &&
              person.mobile_number === null
          )
            ? []
            : state.delivery_address_shipping_keypersons,
      };
      const payload2 = {
        company: state.company,
        company_legal_name: state.company_legal_name,
        site_name: state.site_name,
        gst_number: state.gst_number,
        gst_no_verified: state.gst_no_verified,
        billing_state: state.billing_state,
        billing_city: state.billing_city,
        billing_address_line_1: state.billing_address_line_1,
        billing_address_line_2: state.billing_address_line_2,
        billing_landmark: state.billing_landmark,
        billing_pincode: state.billing_pincode,
        shipping_state: state.shipping_state,
        shipping_city: state.shipping_city,
        shipping_address_line_1: state.shipping_address_line_1,
        shipping_address_line_2: state.shipping_address_line_2,
        shipping_landmark: state.shipping_landmark,
        shipping_pincode: state.shipping_pincode,
        same_as_billing_address: state.same_as_billing_address,
      };
      const payload =
        selectedOption === "Common Wise For Site" ? payload1 : payload2;
      let apiResponse;
      if (AddressId === null) {
        apiResponse = await postRequest("delivery-address/", payload);
      } else {
        apiResponse = await patchRequest(
          `delivery-address/${AddressId}/`,
          payload
        );
      }
      if (apiResponse.data.success) {
        handleTabChange('2')
        SuccessNotificationMsg(
          AddressId === null
            ? t("site_location_added_successfully")
            : t("site_location_updated_successfully")
        );
        setState(initialState);
        formRef.current.setFieldsValue(initialState);
        updateSubscriptionStatus();
        setBtnLoading(false);
        // navigate("/delivery-address");
        // navigate("/company-material-sitewise");
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };

  const handleChange = (name, value) => {
    setState({ ...state, [name]: value });
  };

  const setWeightSizeFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};
    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["persons_name" + objectKey] = objectValue.persons_name;
      fieldObject["email" + objectKey] = objectValue.email;
      fieldObject["mobile_number" + objectKey] = String(
        objectValue.mobile_number
      );
      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };

  const handleSameAsCurrentAddressChange = (e) => {
    const checked = e.target.checked;
    setSameAsCurrentAddress(checked);
    const defaultCountryCode = "+91";
    if (checked) {
      setState((prevState) => {
        return {
          ...prevState,
          same_as_billing_address: true,
          shipping_state: prevState.billing_state,
          shipping_city: prevState.billing_city,
          shipping_address_line_1: prevState.billing_address_line_1,
          shipping_address_line_2: prevState.billing_address_line_2,
          shipping_landmark: prevState.billing_landmark,
          shipping_pincode: prevState.billing_pincode,
          shipping_pincode_number: prevState.billing_pincode_number,
          shipping_email: prevState.billing_email,
          shipping_phone: prevState.billing_phone,
          shipping_alternative_phone_number:
            prevState.billing_alternative_phone_number,
          shipping_contact_person_name: prevState.billing_contact_person_name,
        };
      });
      formRef.current.setFieldsValue({
        shipping_state: state.billing_state,
        shipping_city: state.billing_city,
        shipping_address_line_1: state.billing_address_line_1,
        shipping_address_line_2: state.billing_address_line_2,
        shipping_landmark: state.billing_landmark,
        shipping_pincode: state.billing_pincode_number,
        shipping_email: state.billing_email,
        shipping_phone: state.billing_phone
          ? state.billing_phone
          : defaultCountryCode,
        shipping_alternative_phone_number:
          state.billing_alternative_phone_number
            ? state.billing_alternative_phone_number
            : defaultCountryCode,
        shipping_contact_person_name: state.billing_contact_person_name,
      });

      if (
        state?.billing_state !== null &&
        state?.billing_state !== undefined &&
        state?.billing_state !== ""
      ) {
        //getCityByStateForShipping(state.billing_state); //1 0
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        same_as_billing_address: false,
        shipping_state: "",
        shipping_city: "",
        shipping_address_line_1: "",
        shipping_address_line_2: "",
        shipping_landmark: "",
        shipping_pincode_number: "",
        shipping_email: "",
        shipping_phone: "",
        shipping_alternative_phone_number: "",
        shipping_contact_person_name: "",
      }));

      formRef.current.setFieldsValue({
        shipping_state: "",
        shipping_city: "",
        shipping_address_line_1: "",
        shipping_address_line_2: "",
        shipping_landmark: "",
        shipping_pincode_number: "",
        shipping_pincode: null,
        shipping_email: "",
        shipping_phone: defaultCountryCode,
        shipping_alternative_phone_number: defaultCountryCode,
        shipping_contact_person_name: "",
      });
    }
  };

  const colors = ["#094E8F"];
  return (
    <>
        <div className="ListingTopBar">
            <div className="pagenamewrap">
              <div className="pagename">
              {id ? <h3>Site Location</h3> : <h3>Site Location</h3>}
               
    
                <Breadcrumb className="Breadcrumb-Sec">
                  <Breadcrumb.Item>
                    <Link to="/dashboard">Dashboard</Link>
                  </Breadcrumb.Item>
 
           
                <Breadcrumb.Item>Site Location</Breadcrumb.Item>
             
                 
                 
                </Breadcrumb>
                </div>
         
              
            </div>
          </div>
          <section className="grid-sec FormSection Container">
        <div className="FormBody" style={{padding:'0'}}>
          <div className="stepscontentwrap">
           
            <div className="custom-arrow-tabs">
              <Tabs
                activeKey={activeKey}
                // onChange={handleTabChange}
                className="custom-tabs"
              >
                <TabPane tab="01 Site Basic Detail" key="1">
                  <Spin spinning={apiLoading}>
                    <Form
                      onFinish={handleSubmit}
                      autoComplete="off"
                      ref={formRef} 
                    >
                      <div className="stepsContent">
                        <div className="formwrapper">
                          <div className="formrowsection">
                            <Row gutter={16}>
                              <Col xs={24} sm={24} md={12} xl={8}>
                                <div className="verifywrap">
                                  <Form.Item
                                    label="GST Number"
                                    name="gst_number"
                                    rules={[
                                      {
                                        required: true,
                                        message: (
                                          <Trans>{t("val_gst_number")}</Trans>
                                        ),
                                      },
                                      {
                                        pattern:
                                          /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1})$/,
                                        message: "Enter a valid GST number",
                                      },
                                    ]}
                                  >
                                    <Input
                                      placeholder={t("pl_enter_gst_number")}
                                      value={state.gst_number}
                                      onKeyPress={(e) => {
                                        if (e.key === "." || e.key === "e") {
                                          e.preventDefault();
                                        }
                                      }}
                                      onChange={(e) =>
                                        handleGstInputChange(
                                          "gst_number",
                                          e.target.value
                                        )
                                      }
                                      prefix={<AddressLine />}
                                    />
                                  </Form.Item>
                                  {verifyGstButtonView === true ? (
                                    <ButtonField
                                      type="primary"
                                      label={t("Verify")}
                                      className="SaveGradiantBtn verify"
                                      loading={btnLoadingVerifyGst}
                                      onClick={handleGstNumberVerify}
                                      disabled={
                                        state?.gst_number
                                          ? verifyGstDisable
                                          : true
                                      }
                                    />
                                  ) : (
                                    ""
                                  )}

                                  {verificationStatus === "success" && (
                                    <img
                                      src={verifybtn}
                                      style={{
                                        height: "36px",
                                        marginTop: "29px",
                                      }}
                                    ></img>
                                  )}
                                </div>
                              </Col>
                              <Col xs={24} sm={24} md={12} xl={8}>
                                <InputField
                                  name="company_legal_name"
                                  label="Legal Name Of Business"
                                  pattern={"^[a-zA-Z .]+$"}
                                  placeholder={t(
                                    "Enter legal name of business"
                                  )}
                                  rules={t("val_company_name1")}
                                  prefix={<AddressLine />}
                                  handleInputChange={handleInputChange}
                                />
                              </Col>
                              <Col xs={24} sm={24} md={12} xl={8}>
                                <InputField
                                  name="site_name"
                                  label={
                                    <Tooltip
                                      color={colors}
                                      placement="left"
                                      title={t(
                                        " Site location inserted in this field will be subsiquently used as a dropdown menu during PR, RFQ & PO operations"
                                      )}
                                    >
                                      {t("label_site_short_name")}
                                    </Tooltip>
                                  }
                                  placeholder={t("pl_site_short_name")}
                                  rules={t("val_site_short_name")}
                                  prefix={<AddressLine />}
                                  handleInputChange={handleInputChange}
                                  pattern={"^[a-zA-Z ]+$"}
                                />
                              </Col>
                            </Row>
                          </div>
                          <Row gutter={32}>
                            <Col xs={12} xxl={10} className="bdr">
                              <div className="colwrap">
                                <div className="colsubtitle">
                                  Billing Address
                                </div>
                                <Row gutter={16}>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="billing_address_line_1"
                                      label={t("Shop No, Building")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_please_enter_address")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("pl_enter_shop_no")}
                                        value={state.billing_address_line_1}
                                        onChange={(e) =>
                                          handleChange(
                                            "billing_address_line_1",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="billing_address_line_2"
                                      label={t("Area, Street")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_please_enter_address")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("pl_enter_area_street")}
                                        value={state.billing_address_line_2}
                                        onChange={(e) =>
                                          handleChange(
                                            "billing_address_line_2",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="billing_landmark"
                                      label={t("pl_landmark")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_please_enter_land_mark")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("place_land_mark")}
                                        value={state.billing_landmark}
                                        onChange={(e) =>
                                          handleChange(
                                            "billing_landmark",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="billing_pincode"
                                      label={t("pl_pincode")}
                                      prefix={<ZipCode />}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_postal_zip_code")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <AutoComplete
                                        className="autoComplete"
                                        onSearch={onSearchBilling}
                                        value={state.billing_pincode}
                                        optionFilterProp="children"
                                        allowClear
                                        placeholder={t("pl_pincodeselect")}
                                        onChange={handlePincodeBillingChange}
                                      >
                                        {pincodeListBilling.map((option) => (
                                          <Option
                                            key={option.id}
                                            value={option.pincode_number}
                                          >
                                            {option.pincode_number}
                                          </Option>
                                        ))}
                                      </AutoComplete>
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="billing_city"
                                      label={t("pl_city")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>{t("val_city")}</Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("place_city")}
                                        value={state.billing_city}
                                        disabled
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="billing_state"
                                      label={t("pl_state")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_state_province")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        value={state.billing_state}
                                        placeholder={t("place_state")}
                                        disabled
                                      />
                                    </Form.Item>
                                  </Col>

                                  <BillingSiteLocationKeyPerson
                                    state={state}
                                    setState={setState}
                                    companyId={CompanyId}
                                  />
                                </Row>
                              </div>
                            </Col>
                            <Col xs={12} xxl={10}>
                              <div className="colwrap">
                                <div className="colsubtitle">
                                  Shipping Address
                                  <Tooltip
                                    color={colors}
                                    title="Same as Billing Address"
                                    name="same_as_billing_address"
                                  >
                                    <Checkbox
                                      style={{ marginLeft: "10px" }}
                                      checked={sameAsCurrentAddress}
                                      onChange={(e) =>
                                        handleSameAsCurrentAddressChange(e)
                                      }
                                    >
                                      Same as my billing address
                                    </Checkbox>
                                  </Tooltip>
                                </div>
                                <Row gutter={16}>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="shipping_address_line_1"
                                      label={t("Shop No, Building")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_please_enter_address")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("pl_enter_shop_no")}
                                        value={state.shipping_address_line_1}
                                        onChange={(e) =>
                                          handleChange(
                                            "shipping_address_line_1",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="shipping_address_line_2"
                                      label={t("Area, Street")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_please_enter_address")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("pl_enter_area_street")}
                                        value={state.shipping_address_line_2}
                                        onChange={(e) =>
                                          handleChange(
                                            "shipping_address_line_2",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="shipping_landmark"
                                      label={t("pl_landmark")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_please_enter_land_mark")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("place_land_mark")}
                                        value={state.shipping_landmark}
                                        onChange={(e) =>
                                          handleChange(
                                            "shipping_landmark",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="shipping_pincode"
                                      label={t("pl_pincode")}
                                      prefix={<ZipCode />}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_postal_zip_code")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <AutoComplete
                                        className="autoComplete"
                                        onSearch={onSearchShipping}
                                        value={state.shipping_pincode}
                                        optionFilterProp="children"
                                        allowClear
                                        placeholder={t("pl_pincodeselect")}
                                        onChange={handlePincodeShippingChange}
                                      >
                                        {pincodeListShipping.map((option) => (
                                          <Option
                                            key={option.id}
                                            value={option.pincode_number}
                                          >
                                            {option.pincode_number}
                                          </Option>
                                        ))}
                                      </AutoComplete>
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="shipping_city"
                                      label={t("pl_city")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>{t("val_city")}</Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("place_city")}
                                        value={state.shipping_city}
                                        disabled
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} md={12}>
                                    <Form.Item
                                      name="shipping_state"
                                      label={t("pl_state")}
                                      rules={[
                                        {
                                          required: true,
                                          message: (
                                            <Trans>
                                              {t("val_state_province")}
                                            </Trans>
                                          ),
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder={t("place_state")}
                                        value={state.shipping_state}
                                        disabled
                                      />
                                    </Form.Item>
                                  </Col>

                                  <ShippingSiteLocationKeyPerson
                                    state={state}
                                    setState={setState}
                                    companyId={CompanyId}
                                  />
                                </Row>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>

                      <div className="stepsFooter">
                        <Button
                          cursor="pointer"
                          type="secondary"
                          className="primary"
                          onClick={() => navigate("/delivery-address")}
                        >
                          Cancel
                        </Button>
                        <Button
                          cursor="pointer"
                          type="primary"
                          className="primary"
                          htmlType="Submit"
                          label={t("save")}
                          loading={btnLoading}
                        >
                          Save & Next
                        </Button>
                      </div>
                    </Form>
                  </Spin>
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      02 Selection Of Material{" "}
                      <Tooltip
                        color="#094E8F"
                        placement="right"
                        title={
                          <span style={{ color: "#fff" }}>
                            Please select or deselect the materials to be used at this specific site location. Note that only the materials selected here will be available for the PR to PO process for this site.
                          </span>
                        }
                      >
                       <InfoCircleOutlined
                style={{ color: "white", marginLeft: "3px" }}
              />
                      </Tooltip>
                    </span>
                  }
                  key="2"
                >
                  <SiteMaterialStep setActiveKey = {handleTabChange}/>
                </TabPane>
              </Tabs>
            </div>
          </div>
      </div></section>
    </>
  );
};

export default EditMaterial;
